import CheckIcon from "@mui/icons-material/Check";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Button, Paper, Snackbar, Stack } from "@mui/material";
import { ReactNode } from "react";

interface BulkActionSnackbarProps {
  selectedCount: number;
  isLoading: boolean;
  confirmShow: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** The action button content in default state, e.g. "Remove Members" */
  actionLabel: ReactNode;
  /** The action button content in confirm state, e.g. "Confirm? Removing (3)" — defaults to "Confirm? (count)" */
  confirmLabel?: ReactNode;
  /** Button color — defaults to "error" */
  color?: "error" | "warning" | "primary" | "success";
}

export default function BulkActionSnackbar({
  selectedCount,
  isLoading,
  confirmShow,
  onConfirm,
  onCancel,
  actionLabel,
  confirmLabel = "Confirm",
  color,
}: BulkActionSnackbarProps) {
  return (
    <Snackbar
      open={selectedCount > 0}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ bottom: { xs: 24, sm: 32 }, mb: 3 }}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: "67px",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          sx={{
            px: 4,
            py: 1.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={onCancel}
            color="secondary"
            sx={{
              minWidth: 160,
              borderRadius: "50px",
              textTransform: "none",
              fontSize: 14,
              fontWeight: 500,
              px: 3,
              py: 0.75,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={
              confirmShow ? <CheckIcon /> : <RemoveCircleOutlineIcon />
            }
            onClick={onConfirm}
            disabled={isLoading}
            sx={{
              minWidth: 160,
              borderRadius: "50px",
              textTransform: "none",
              fontSize: 14,
              fontWeight: 500,
              px: 3,
              py: 0.75,
            }}
            color={color}
          >
            {confirmShow ? confirmLabel : actionLabel}
          </Button>
        </Stack>
      </Paper>
    </Snackbar>
  );
}
